import { Button } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import ilustracion from 'assets/img/pies.png';
// eslint-disable-next-line no-unused-vars
import activeCheck from 'assets/img/activeCheck.svg';
// eslint-disable-next-line no-unused-vars
import { setLoginRedirectSSO } from 'util/navigation';
import { useWindowSize } from 'hooks';
import styles from './style.module.scss';

const HomeBenefits = ({ isLoggedIn, setLoginRedirect }) => {
  const [, { isMobile }] = useWindowSize()

  return (
    <>
      {
        isMobile && <div
          className={`mx-auto mb-lg-0 responsive ${styles.illustration}`}
          style={{
            backgroundImage: `url(${ilustracion})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            minHeight: '320px', // Ajusta la altura mínima según tus necesidades
          }}
        />
      }
      <section className={styles.HomeBenefits}>
        <div className="container">
          <div className="row">
            {
              !isMobile && <div className="col-lg-7 col-md-12 order-lg-0">
                <div
                  className={`mx-auto mb-5 mb-lg-0 responsive ${styles.illustration}`}
                  style={{
                    backgroundImage: `url(${ilustracion})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    minHeight: '200px', // Ajusta la altura mínima según tus necesidades
                  }}
                />
              </div>
            }
            <div className="col-lg-5 col-md-12 order-lg-1">
              <div>
                <h3 className={`${styles.title} mb-4 text-center`}>
                  Conoce nuestros beneficios:
                </h3>
                <ul className={`${styles.list} list-unstyled`}>
                  <li style={{ backgroundImage: `url(${activeCheck})` }}>
                    Experimenta <strong>lo mejor</strong> de ambos mundos: Recibe tus regalos en casa con <strong>envío GRATIS</strong> o recibe un <strong>monedero SEARS.</strong>
                  </li>
                  <li style={{ backgroundImage: `url(${activeCheck})` }}>
                    Los <strong>invitados</strong> podrán comprar los regalos desde la <strong>tienda física</strong>  o de manera <strong>virtual </strong> en <a href="https://www.sears.com.mx" >www.sears.com.mx</a>.
                  </li>
                  <li style={{ backgroundImage: `url(${activeCheck})` }}>
                    Recibe hasta <strong>10% de bonificación</strong> sobre tus compras.
                  </li>
                  <li style={{ backgroundImage: `url(${activeCheck})` }}>
                    Regalo de bienvenida en eventos de <strong>Boda, Baby Shower, XV Años, Primera Comunión y Bautizo</strong>. (<strong>Aplica monto mínimo de compra para canje del obsequio</strong>).
                  </li>
                  <li style={{ backgroundImage: `url(${activeCheck})` }}>
                    Notificaciones en <strong>tiempo real.</strong>
                  </li>
                  <li style={{ backgroundImage: `url(${activeCheck})` }}>
                    <strong>Personaliza tu mesa</strong> con fotografías, mensajes para tus invitados y notas de agradecimiento.
                  </li>
                </ul>
                <div className="text-center">
                  <a className="link-button center" href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
                    <Button variant="primary" className={`border-0 px-4 ${styles.mobileButton}`}>
                      Crear mi mesa de regalos
                    </Button>
                  </a>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HomeBenefits;
